export function linkPrefetch(url: string, debug = false): boolean {
  try {
    const l = document.createElement("link");
    l.rel = "prefetch";
    l.href = url;
    l.as = "document";
    document.head.appendChild(l);
    if (debug) console.log("[HyperInstant] link prefetch:", url);
    return true;
  } catch {
    return false;
  }
}
